import { getProgramStatus, ProgramStatusesOptions, ProgramStatusOption } from '../../types';
import { Form } from 'react-bootstrap';
import { ColoredSelect } from '../ColoredSelect';
import { ModalDropdownMenuZIndex } from '../../util';
import React from 'react';

export const ProgramEditStatus = ({
  setValue,
  value,
  isDisabled,
}: {
  setValue: (s: ProgramStatusOption) => void;
  value: ProgramStatusOption;
  isDisabled: boolean;
}) => (
  <Form.Group controlId="status" className="growegy-form__row">
    <label className="growegy-form__label">Status</label>
    <div>
      <ColoredSelect
        initialValue={getProgramStatus(value.id)}
        coloredItems={[...ProgramStatusesOptions]}
        onValueChange={(value) => setValue(value)}
        dataTestPrefix="program-edit-statuses"
        disabled={isDisabled}
        menuZIndex={ModalDropdownMenuZIndex}
      />
    </div>
  </Form.Group>
);
